import React from 'react';
import Layout from '../../components/Layout';
import blogd1 from '../../assets/images/2022/medical-outreach/fakenews.jpg';
import NavOne from '../../components/NavOne';
import PageHeader from '../../components/PageHeader';
import Footer from '../../components/Footer';

const NewsDetails = () => {
  return (
    <section className='blog-details'>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-12'>
            <div className='blog-one__single'>
              <div className='blog-one__image'>
                <img src={blogd1} alt='' />
              </div>
              <div className='blog-one__content text-center'>
                <h2 className='blog-one__title'>BEWARE OF FAKE NEWS/INFORMATION</h2>
                <p className='blog-one__text' style={{ marginBottom: 30 }}>
                  Lagos University Teaching Hospital (LUTH) wishes to draw
                  the attention of the Nigerian populace, especially applicants to our Schools
                  to the fraudulent message being spread on the
                  Internet about applications like the one above. 
                  Kindly follow our official website or pages for authenthic infomation/news.
                </p>
              </div>
            </div>
            <div className='share-block'>
              {/* <div className='social-block'>
              <a href='#none'>
                <i className='fab fa-twitter'></i>
              </a>
              <a href='#none'>
                <i className='fab fa-facebook-f'></i>
              </a>
              <a href='#none'>
                <i className='fab fa-instagram'></i>
              </a>
              <a href='#none'>
                <i className='fab fa-dribbble'></i>
              </a>
            </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const GalleryPage = () => {
  return (
    <Layout pageTitle='Fake News  | LUTH News'>
      <NavOne />
      <PageHeader title='' />
      <NewsDetails />
      <Footer />
    </Layout>
  );
};

export default GalleryPage;
